<template>
	<Page>
		<img :src="qrcode" class="qr" />
		<BaseField :value="wallet.address" />

		<template #footer>
			<BaseButton @click="back">Back</BaseButton>
		</template>
	</Page>
</template>

<script setup lang="ts">
import BaseButton from '@/components/ui/BaseButton.vue';
import BaseField from '@/components/ui/BaseField.vue';
import Page from '@/components/ui/Page.vue';
import { useTelegram } from '@/composables/useTelegram';
import { useWalletStore } from '@/stores/useWalletStore';
import { useQRCode } from '@vueuse/integrations/useQRCode';
import { useRouter } from 'vue-router';

const router = useRouter();
const wallet = useWalletStore();
// const { telegram } = useTelegram();

const qrcode = useQRCode(wallet.address!, {
	margin: 1
});

const back = () => {
	router.back();
};

const share = () => {
	// const er = `https://t.me/share/url?url=${`${decodeURIComponent(
	// 	`${decodeURIComponent(or)}&text=${Ft('share_qrcode_desc_tgurl')}`
	// )}`}`;
	// Yt.openTelegramLink(er), !se && zt.close();
};
</script>

<style scoped>
.qr {
	padding: 500px;
	background-color: var(--secondary-background-color);
	padding: var(--size-s);
	border-radius: var(--size-xs);
}
</style>
